module.exports = __webpack_public_path__ + "img/weddings_04_H.44ba6c06.webp";